import React from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import PeriodDropdown from './dropdown/period-dropdown';
ChartJS.register(ArcElement, Tooltip, Legend);
export default function DoughnutChat({ values, totalUsers, options = [], onPeriodChange }) {
    const labels = ['広告', '検索エンジン', '直接訪問'];
    const colors = ['#FFA500', '#6B8AFD', '#9B6DD7'];
    const safeValues = values.every(v => v === 0) ? [1, 1, 1] : values;
    const data = {
        labels,
        datasets: [{
                data: safeValues,
                backgroundColor: colors,
                borderWidth: 0,
                cutout: '75%'
            }]
    };
    const total = values.reduce((sum, v) => sum + v, 0) || 1;
    const getPercentage = val => (val / total * 100).toFixed(1);
    return /*#__PURE__*/ React.createElement("div", {
        className: "relative flex flex-col md:flex-row justify-between gap-6 rounded-lg bg-white w-full h-full"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col"
    }, /*#__PURE__*/ React.createElement("p", {
        className: "text-md text-gray-600 mb-1"
    }, "\u6D41\u5165\u7D4C\u8DEF"), /*#__PURE__*/ React.createElement("p", {
        className: "text-3xl font-bold text-blue-600"
    }, totalUsers, "\u30E6\u30FC\u30B6\u30FC")), options.length > 0 && /*#__PURE__*/ React.createElement("div", {
        className: "absolute right-10 top-5"
    }, /*#__PURE__*/ React.createElement(PeriodDropdown, {
        options: options,
        onChange: onPeriodChange,
        defaultValue: "this_week"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "w-[340px] flex items-center justify-center"
    }, /*#__PURE__*/ React.createElement(Doughnut, {
        data: data,
        options: {
            plugins: {
                legend: {
                    display: false
                }
            }
        }
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col w-80 justify-center gap-2 text-sm text-gray-700"
    }, labels.map((label, idx) => /*#__PURE__*/ React.createElement("div", {
        key: label,
        className: "flex items-center gap-2 text-xl"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "inline-block w-2 h-2 rounded-full",
        style: {
            backgroundColor: colors[idx]
        }
    }), /*#__PURE__*/ React.createElement("span", {
        className: "text-gray-700 font-medium"
    }, label), /*#__PURE__*/ React.createElement("span", {
        className: "text-gray-400"
    }, values[idx], "/", totalUsers, " ", getPercentage(values[idx]), "%")))));
}
